export const getClientId = () => {
  let id = localStorage.getItem("wraith_client_id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("wraith_client_id", id);
  }
  return id;
};
